/* RESPONSIBLE TEAM: team-proactive-support */
function poweredByHtml(template_data) {
  if (template_data.show_powered_by) {
    return {
      type: 'html',
      content: `<table class="powered-by-table" style="width: 100%; border-collapse: collapse; color: #545454; font-family: \'Helvetica\',Arial,sans-serif; font-size: 13px; line-height: 20px; margin: 0 auto; max-width: 100%; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; letter-spacing: 0.02em;"><tbody><tr><td style="text-align: center; width:100%; padding: 15px 0; color: #646462; font-size: 11px;">${template_data.powered_by_link}<br></td></tr></tbody></table><style>table.container .powered-by-table a {font-weight: bold; text-decoration: none; color: #646462;}</style>`,
    };
  }

  return { type: 'paragraph', text: '' };
}

export default function (template_data) {
  return {
    blocks: [
      {
        type: 'table',
        style: {
          backgroundColor: '#F9F9F9',
        },
        sectionType: 'header',
        responsive: false,
        container: true,
        stacked: true,
        rows: [
          {
            cells: [
              {
                style: {
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                },
                content: [
                  {
                    type: 'spacer',
                    height: 28,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: 'table',
        sectionType: 'content',
        responsive: false,
        container: true,
        stacked: true,
        rows: [
          {
            cells: [
              {
                content: [
                  {
                    type: 'paragraph',
                    text: '{{content}}',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: 'table',
        style: {
          backgroundColor: '#F9F9F9',
        },
        sectionType: 'footer',
        responsive: false,
        container: true,
        stacked: true,
        rows: [
          {
            cells: [
              {
                style: {
                  paddingTop: '10px',
                  paddingBottom: '0px',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                },
                content: [
                  {
                    type: 'html',
                    content:
                      '<table width="100%" cellpadding="0" cellspacing="0" border="0">\n  <tr>\n    <td width="75%" class="footer-td-wrapper">\n      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; color: #545454; font-family: \'Helvetica\',Arial,sans-serif; font-size: 13px; line-height: 20px; margin: 0 auto; max-width: 100%; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%" class="message_footer_table">\n        <tbody>\n          <tr>\n            <td width="40" class="space" style="width:20px; font-size: 12px;"> </td>\n            <td valign="middle" width="50" align="left" class="{{hide_avatar}}" style="font-size: 12px">\n              {{admin_avatar}}\n            </td>\n            <td class="admin_name" style="color: #646462; display: table-cell; font-size: 12px; vertical-align: middle;">\n              {{admin_name_and_app}}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </td>\n    <td width="25%" class="{{unsubscribeLinkClass}}" style="display: block; width: 100%; text-align: left;">\n      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; color: #545454; font-family: \'Helvetica\',Arial,sans-serif; font-size: 13px; line-height: 20px; margin: 0 auto; max-width: 100%; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%" class="message_footer_table">\n        <tr>\n          <td valign="middle" align="right" style="color: #646462 !important; text-decoration: underline !important; text-align: right; font-size: 11px; padding: 15px 0 0 0; display: table-cell; vertical-align: middle;">\n            <a class="ic-unsubscribe-link" href="#">{{unsubscribe_link}}</a>\n          </td>\n        <tr>\n      </table>\n    </td>\n  </tr>\n</table>\n\n<style>\n  .message_footer_table .avatar {\n    -ms-interpolation-mode: bicubic;\n    -webkit-background-clip: padding-box;\n    -webkit-border-radius: 20px;\n    background-clip: padding-box;\n    border-radius: 20px;\n    display: inline-block;\n    height: 40px;\n    max-width: 100%;\n    outline: none;\n    text-decoration: none;\n    width: 40px;\n  }\n  .admin_name b {\n    color: #6f6f6f;\n  }\n  a.ic-unsubscribe-link {\n    color: #646462 !important;\n    text-decoration: underline;\n  }\n  .message_footer_table .admin_name b{\n    display: block !important;\n  }\n  table.container h1 {\n    line-height: 33px;\n    color: #1d364b;\n    margin-bottom: 7px;\n    margin-top: 30px;\n  }\n\n  table.container h1 a{\n    color: #1d364b;\n    text-decoration: underline;\n  }\n\n  table.container h2 {\n    font-weight: bold;\n    color: #1d364b;\n    margin: 30px 0 7px;\n  }\n\n  table.container h2 a {\n    color: #1d364b;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n  table.container h1 + h2 {\n    margin-top: 0;\n  }\n  table.container p a, table.container small a {\n    text-decoration: underline;\n  }\n  table.container ic-block, table.container .embercom-prosemirror-composer-block-container, table.container .intercom-interblocks div {\n    margin: 17px 0;\n  }\n table.body p {\n margin: 0 0 17px 0;\n line-height: 1.5;\n}\n table.body ol, table.body ul {\n margin: 0 0 20px 40px;\n padding: 0;\n}\n table.body div.intercom-container {\n margin-bottom: 17px;\n margin-top: 17px;\n line-height: 0;\n}\n </style>',
                  },
                  poweredByHtml(template_data),
                ],
              },
            ],
          },
        ],
      },
    ],

    contentBlocks: [
      {
        type: 'table',
        sectionType: 'content',
        responsive: false,
        container: true,
        stacked: true,
        rows: [
          {
            cells: [
              {
                style: {
                  paddingTop: '35px',
                  paddingBottom: '30px',
                  paddingLeft: '40px',
                  paddingRight: '40px',
                },
                content: [
                  {
                    type: 'paragraph',
                    text: '',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],

    css: {
      body_background_color: '#f9f9f9',
      container_background_color: '#FFFFFF',
      template_font_color: '#666666',
      template_font_family: null,
      template_link_font_color: '#1251ba',
      template_link_font_weight: null,
      template_link_font_style: null,
      h1_font_size: 26,
      h2_font_size: 18,
      paragraph_font_size: 15,
      small_font_size: null,
    },
  };
}
